import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TokenListService} from './token-list.service';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {Router} from '@angular/router';
import {PaginationInstance} from 'ngx-pagination';
import {Observable, Subscription} from 'rxjs/Rx';
import {TrnServiceCabinScheduleService} from '../configuration/trn-service-cabin-schedule/trn-service-cabin-schedule.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {MstSubDepartmentService} from '../configuration/mst-sub-department/mst-sub-department.service';
import {MstDepartmentService} from '../configuration/mst-department/mst-department.service';
import {MstCabinService} from '../configuration/mst-cabin/mst-cabin.service';
import {MstStaffService} from '../configuration/mst-staff/mst-staff.service';
import {MstSpecialityService} from '../configuration/mst-speciality/mst-speciality.service';
import {Aarogyam, Iilds, Karad, Medikal, MK, Nepal, Tata, Turkish,YCM} from '../shared/my-constants';
import {MstVisitService} from '../configuration/mst-visit/mst-visit.service';

import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './token-list.component.html',
    styleUrls: ['./token-list.component.css']
})
export class TokenListComponent implements OnInit {
    tokenData: any;
    groupedData: { staffId: string, tokens: any[] }[] = [];
    public date: Date = new Date();
    staffid: Number = 0;
    dept: String = null;
    currentUser: any;
    tokeStaffList: any;
    // tokenData: Array<any> = [];
    tokenDatalen: Number = 0;
    multiplesearch: any = [];
    mstUnit: any;
    LoginForm: FormGroup;
    loading: boolean;
    mstTokenList: Array<any> = [];
    mstCabin: any;
    userDept: any = {};
    unitid: any;
    unitName: any;
    private subscription;
    currentUserdetails: any;
    departments: any = [{'department_id': 0, 'department_name': 'Oncology'}, {
        'department_id': 1,
        'department_name': 'Others'
    }];
    mstUnitList: Array<any> = [];
    mstDepartmentList: Array<any> = [];
    departmentList: Array<any> = [];
    subDepartmentList: Array<any> = [];
    selectedDepartmentList = [];
    selectedSubDepartmentList = [];
    mstSubDepartmentList: Array<any> = [];
    mstSpecialityList: Array<any> = [];
    mstDoctorList: Array<any> = [];
    patientlistByDoc: Array<any> = [];
    doctorList: Array<any> = [];
    doctorList2: Array<any> = [];
    selectedDoctorList: Array<any> = [];
    mstCabinList: Array<any> = [];
    selectedUnit: any = {};
    data: any = {};
    specialityList: Array<any> = [];
    selectedSpecialityList: Array<any> = [];
    cabinList: Array<any> = [];
    selectedCabinList: Array<any> = [];
    departmentWiseSearch:Boolean= false;
    specialitySearch:Boolean= false;
    cabintWiseSearch:Boolean= false;
    selectedToken: any = {};
    private timer;
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 1
    };
    iilds: Boolean = Iilds;
    nepal: Boolean = Nepal;
    ycm: Boolean = YCM;
    aarogyam: Boolean = Aarogyam;
    medikal: Boolean = Medikal;
    turkish: Boolean = Turkish;
    mk: Boolean = MK;
    karad: Boolean = Karad;
    refreshSubscription: Subscription;


    constructor(private fb: FormBuilder, private tokenListService: TokenListService, private router: Router, public toastr: ToastsManager, vcr: ViewContainerRef,
                private trnServiceCabinScheduleService: TrnServiceCabinScheduleService, private mstUnitService: MstUnitService, private mstStaffService: MstStaffService,
                private mstDepartmentService: MstDepartmentService, private mstSubDepartmentService: MstSubDepartmentService, private mstCabinService: MstCabinService,
                private mstSpecialityService: MstSpecialityService, private mstVisitService: MstVisitService) {
        this.toastr.setRootViewContainerRef(vcr);
        Observable.interval(10000)
            .map((x) => x + 0)
            .subscribe((x) => {
                 this.getPage(1);
                // this.ngOnInit();
                this.date = new Date();
            });
    }

    ngOnInit() {
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
        this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
        this.unitName = sessionStorage.getItem('unitName');
        this.tokeStaffList = localStorage.getItem('TokenStaff');

        this.mstVisitService.loadTodayToken(this.tokeStaffList).then(resp => {
            console.table(resp);

            // this.tokenData = resp;
            // this.tokenDatalen = this.tokenData.length;
            // console.log(this.tokenDatalen);
        });

        this.selectedUnit = {unitId: this.unitid, unitName: this.unitName};
        this.getUnitDetailsById(this.unitid);
        let event: any = {};
        event.key = null;
        event.key = '';
        this.multiplesearch.departmentWiseSearch = false;
        this.multiplesearch.specialitySearch = false;
        this.multiplesearch.cabintWiseSearch = false;
        this.multiplesearch.showPatientQueue = true;
        this.multiplesearch.showPatientCall = true;
        this.multiplesearch.nonofabove = false;
        this.multiplesearch.video = true;
        this.multiplesearch.showScrollMessage = false;
        this.multiplesearch.scrollMessage = '';

        // this.getPage(1);
        this.getUnitList(event);
    }
    // ngOnDestroy() {
    //     this.stopDataRefresh();
    // }
    //
    // stopDataRefresh() {
    //     if (this.refreshSubscription) {
    //         this.refreshSubscription.unsubscribe();
    //     }
    // }
    // startDataRefresh() {
    //     this.refreshSubscription =  Observable.interval(10000)
    //         .pipe(
    //             switchMap(() => this.mstVisitService.loadTodayToken(this.tokeStaffList))
    //         )
    //         .subscribe((resp) => {
    //             console.table(resp);
    //             this.tokenData = this.groupTokenData(resp);
    //             this.tokenDatalen = this.tokenData.length;
    //             console.log(this.tokenDatalen);
    //             this.date = new Date();
    //         });
    // }

     getPage(page: number) {
        if (this.multiplesearch.departmentWiseSearch == false && this.multiplesearch.cabintWiseSearch == false && this.multiplesearch.specialitySearch == false) {
            // console.log("none");
            this.tokeStaffList = localStorage.getItem('TokenStaff');
            this.mstVisitService.loadTodayToken(this.tokeStaffList).then(resp => {
                console.table(resp);

                if (resp) {
                    this.tokenData = this.groupTokenData(resp);
                    this.tokenDatalen = this.tokenData.length;
                    console.log(this.tokenDatalen);
                     this.ngOnInit();
                } else {
                    // Handle the case where tokenData is null or undefined
                }
            });

            this.trnServiceCabinScheduleService.getTokenDisplayByUnitId(this.unitid)
                .then(resp => {
                    this.mstTokenList = [];
                    this.mstTokenList = resp;
                    console.log('not search token');
                    console.log(resp);
                    this.selectedToken = {};
                    if (this.mstTokenList.length != 0) {
                        this.selectedToken = this.mstTokenList[0];
                        this.mstTokenList = this.mstTokenList.filter(token => token.scsId != this.selectedToken.scsId);
                    }
                });
        }
        else {
            this.mstTokenList = [];
            // this.trnServiceCabinScheduleService.getTokenDisplayByDoctorList(this.selectedDoctorList)
            //     .then(resp2 => {
            //         this.mstTokenList = resp2;
            //         // console.log("search token");
            //         // console.log(resp2);
            //         this.selectedToken = {};
            //         if (this.mstTokenList.length != 0) {
            //             this.selectedToken = this.mstTokenList[0];
            //             this.mstTokenList = this.mstTokenList.filter(token => token.scsId != this.selectedToken.scsId);
            //         }
            //     });
        }
    }


     groupTokenData(tokenData: any[]): any[] {
        const groupedData =  tokenData.reduce((acc, obj) => {
            const key = obj.staffId;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});

        console.log(groupedData);

        return Object.keys(groupedData).map(key => ({ staffId: key, tokens: groupedData[key] }));
    }


    // submit() {
    //     this.getPage(1);
    // }

    getUnitDetailsById(id: any) {
        this.mstUnitService.getRecordService(id)
            .then(resp => {
                this.mstUnit = resp;
            });
    }

    getUnitList(event: any) {
        // console.log(event.key);
        this.mstUnitService.getAllDropDown(1, 10, event.key)
            .then(resp => {
                this.mstUnitList = resp;
                // console.log("mstUnitList");
                // console.log(this.mstUnitList);
                let event: any = {};
                event.key = null;
                event.key = '';
                this.selectedDepartmentList = [];
                this.getDepartmentList(event);
                this.getSpecialityList();
                this.getCabinList();
            });
    }

    onSelectUnit(event: any) {
        // console.log(event);
        this.selectedUnit = event;
    }

    radioButton(event: any, buttonName: any) {
        if (buttonName == 'departmentWiseSearch') {
            this.multiplesearch.departmentWiseSearch = true;
            this.multiplesearch.specialitySearch = false;
            this.multiplesearch.cabintWiseSearch = false;
            this.multiplesearch.nonofabov = false;
            this.doctorList = [];
            this.mstDoctorList = [];
            this.multiplesearch.selectedDoctorList = [];
        }
        else if (buttonName == 'specialitySearch') {
            this.multiplesearch.departmentWiseSearch = false;
            this.multiplesearch.specialitySearch = true;
            this.multiplesearch.cabintWiseSearch = false;
            this.multiplesearch.nonofabov = false;
            this.doctorList = [];
            this.mstDoctorList = [];
            this.multiplesearch.selectedDoctorList = [];
        }
        else if (buttonName == 'nonofabove') {
            this.multiplesearch.departmentWiseSearch = false;
            this.multiplesearch.specialitySearch = false;
            this.multiplesearch.cabintWiseSearch = false;
            this.multiplesearch.nonofabov = true;
            this.doctorList = [];
            this.mstDoctorList = [];
            this.multiplesearch.selectedDoctorList = [];
        }
        else {
            this.multiplesearch.departmentWiseSearch = false;
            this.multiplesearch.specialitySearch = false;
            this.multiplesearch.cabintWiseSearch = true;
            this.multiplesearch.nonofabov = false;
            this.doctorList = [];
            this.mstDoctorList = [];
            this.multiplesearch.selectedDoctorList = [];
        }
        // console.log("radio");
        // console.log(this.multiplesearch.departmentWiseSearch);
        // console.log(this.multiplesearch.specialitySearch);
        // console.log(this.multiplesearch.cabintWiseSearch);
        // console.log(this.multiplesearch.nonofabov);
    }

    getDepartmentList(event: any) {
        this.departmentList = [];
        this.mstDepartmentList = [];
        this.mstDepartmentService.getAllDropDown(1, 10, event.key, this.selectedUnit.unitId)
            .then(resp => {
                this.mstDepartmentList = resp;
                // console.log("mstDepartmentListList");
                // console.log(resp);
                for (let dept of this.mstDepartmentList) {
                    this.departmentList.push({label: dept.departmentName, value: dept.departmentId});
                }
                //     this.multiplesearch.selectedDepartment = {};
            });
    }

    selectedDepartment() {
        // console.log(this.selectedDepartmentList);
        // if (this.selectedDepartmentList != null) {
        //   for (let d of this.selectedDepartmentList) {
        //     if (this.multiplesearch.selectedDepartment == undefined) {
        //       this.multiplesearch.selectedDepartment =   "'" + d + "'" + ","
        //     }
        //     else{
        //
        //       this.multiplesearch.selectedDepartment +=  "'" + d + "'"  + ","
        //     }
        //   }
        // }
        // console.log(this.multiplesearch);
        let event: any = {};
        event.key = null;
        event.key = '';
        this.getSubdepartmentList(event);
    }

    getSubdepartmentList(event: any) {
        if (this.selectedDepartmentList.length != 0) {
            this.subDepartmentList = [];
            this.selectedSubDepartmentList = [];
            this.mstSubDepartmentService.getAllDropDown(1, 10, event.key, this.selectedDepartmentList)
                .then(resp => {
                    this.mstSubDepartmentList = resp;
                    // console.log("mstSubDepartmentList");
                    // console.log(resp);
                    for (let subDept of this.mstSubDepartmentList) {
                        this.subDepartmentList.push({label: subDept.sdName, value: subDept.sdId});
                    }
                });
        }
        else {
            this.subDepartmentList = [];
            this.selectedSubDepartmentList = [];
        }
    }

    selectedSubDepartment() {
        // console.log(this.selectedSubDepartmentList)
        this.multiplesearch.selectedSubDepartment = [];
        if (this.selectedSubDepartmentList != null) {
            for (let d of this.selectedSubDepartmentList) {
                if (this.multiplesearch.selectedSubDepartment == undefined) {
                    this.multiplesearch.selectedSubDepartment = '\'' + d + '\'' + ',';
                }
                else {
                    this.multiplesearch.selectedSubDepartment += '\'' + d + '\'' + ',';
                }
            }
        }
        // console.log("multiplesearch");
        // console.log(this.multiplesearch);
        let event: any = {};
        event.key = null;
        event.key = '';
        this.getDoctor(event, 'subdepartment');
    }

    getDoctor(event: any, searchtype: any) {
        // console.log(event);
        if (searchtype === 'subdepartment') {
            if (this.multiplesearch.selectedSubDepartment.length != 0) {
                this.doctorList = [];
                this.mstDoctorList = [];
                this.mstStaffService.getAllDropDown(1, 10, event.key, this.multiplesearch.selectedSubDepartment)
                    .then(resp => {
                        this.mstDoctorList = resp;
                        // console.log("mstDoctorList");
                        // console.log(resp);
                        for (let doc of this.mstDoctorList) {
                            this.doctorList.push({label: doc.fullname, value: doc.staffId});
                            // this.doctorList2.push();
                        }

                    });

                this.data.sdId = this.multiplesearch.selectedSubDepartment
                console.log('this.data',this.data);
                this.trnServiceCabinScheduleService.getTokenDisplayBysdiDList(this.data) .then( resp => {
                    this.mstDoctorList = resp;

                    // let docList = [];
                    // if(resp.legth > 0){
                    //    docList[0] = this.mstDoctorList[0][2];
                    // }
                    // for(let i=0; i>this.mstDoctorList.length; i++){
                    //     if(docList[i]==this.mstDoctorList[i]){}
                    // }
                    //
                    // console.log("mstDoctorList nayan " , resp);
                });
            }
            else {
                this.doctorList = [];
                this.mstDoctorList = [];
            }
        }
        else if (searchtype === 'speciality') {
            if (this.multiplesearch.selectedSpecialityList.length != 0) {
                this.doctorList = [];
                this.mstDoctorList = [];
                this.mstStaffService.getAllDropDownBySpecialityList(1, 10, event.key, this.multiplesearch.selectedSpecialityList)
                    .then(resp => {
                        this.mstDoctorList = resp;
                        // console.log("mstDoctorList");
                        // console.log(resp);
                        for (let doc of this.mstDoctorList) {
                            this.doctorList.push({label: doc.fullname, value: doc.staffId});
                        }
                    });
            }
            else {
                this.doctorList = [];
                this.mstDoctorList = [];
            }
        }
        else {
            if (this.multiplesearch.selectedCabinList.length != 0) {
                this.doctorList = [];
                this.mstDoctorList = [];
                this.mstStaffService.getAllDropDownByCabinList(1, 10, event.key, this.multiplesearch.selectedCabinList)
                    .then(resp => {
                        this.mstDoctorList = resp;
                        // console.log('mstDoctorList');
                        // console.log(resp);
                        for (let doc of this.mstDoctorList) {
                            this.doctorList.push({label: doc.fullname, value: doc.staffId});
                        }
                    });
            }
            else {
                this.doctorList = [];
                this.mstDoctorList = [];
            }
        }
    }

    selectedDoctor() {
        // console.log(this.selectedDoctorList);
        // this.multiplesearch.selectedDoctorList = [];
        // if (this.selectedDoctorList != null) {
        //   for (let d of this.selectedDoctorList) {
        //     if (this.multiplesearch.selectedDoctorList == undefined) {
        //       this.multiplesearch.selectedDoctorList = "'" + d + "'" + ","
        //     }
        //     else {
        //       this.multiplesearch.selectedDoctorList += "'" + d + "'" + ","
        //     }
        //   }
        // }
        // console.log(this.multiplesearch);
    }

    selectedSpeciality() {
        // console.log(this.selectedSpecialityList);
        this.multiplesearch.selectedSpecialityList = [];
        if (this.selectedSpecialityList != null) {
            for (let d of this.selectedSpecialityList) {
                if (this.multiplesearch.selectedSpecialityList == undefined) {
                    this.multiplesearch.selectedSpecialityList = '\'' + d + '\'' + ',';
                }
                else {
                    this.multiplesearch.selectedSpecialityList += '\'' + d + '\'' + ',';
                }
            }
        }
        // console.log("multiplesearch");
        // console.log(this.multiplesearch);
        let event: any = {};
        event.key = null;
        event.key = '';
        this.getDoctor(event, 'speciality');
    }

    getSpecialityList() {
        this.specialityList = [];
        this.mstSpecialityList = [];
        this.mstSpecialityService.getDropDownUnitWise(1, 10, '')
            .then(resp => {
                this.mstSpecialityList = resp;
                // console.log("mstSpecialityList");
                // console.log(resp);
                for (let spec of this.mstSpecialityList) {
                    this.specialityList.push({label: spec.specialityName, value: spec.specialityId});
                }
            });
    }

    getCabinList() {
        this.mstCabinList = [];
        this.cabinList = [];
        this.mstCabinService.getAllDropDown(1, 10, '')
            .then(resp => {
                this.mstCabinList = resp;
                // console.log("mstCabinList");
                // console.log(resp);
                for (let spec of this.mstCabinList) {
                    this.cabinList.push({label: spec.cabinName, value: spec.cabinId});
                }
            });
    }

    selectedCabin() {
        // console.log(this.selectedCabinList);
        this.multiplesearch.selectedCabinList = [];
        if (this.selectedCabinList != null) {
            for (let d of this.selectedCabinList) {
                if (this.multiplesearch.selectedCabinList == undefined) {
                    this.multiplesearch.selectedCabinList = '\'' + d + '\'' + ',';
                }
                else {
                    this.multiplesearch.selectedCabinList += '\'' + d + '\'' + ',';
                }
            }
        }
        // console.log("multiplesearch");
        // console.log(this.multiplesearch);
        let event: any = {};
        event.key = null;
        event.key = '';
        this.getDoctor(event, 'cabin');
    }

    onSelectedShowPatientQueue(event: any) {
        // console.log(event.target.checked);
        this.multiplesearch.showPatientQueue = event.target.checked;
    }

    onSelectedShowPatientCall(event: any) {
        console.log(event);
        this.multiplesearch.showPatientCall = event.target.checked;
    }

    onSelectedVideo(event: any) {
        // console.log(event);
        this.multiplesearch.video = event.target.checked;
    }

    onScrollMessage(event: any) {
        // console.log(event);
        this.multiplesearch.showScrollMessage = event.target.checked;
        if (event.target.checked === false) {
            this.multiplesearch.scrollMessage = '';
        }
    }

    onApply() {
        console.log(this.selectedDoctorList);
        // console.log(this.multiplesearch);
        let doc = '';
        this.selectedDoctorList.forEach(d => {
            doc += d.toString() + ',';
        });
        doc += '0';
        localStorage.setItem('TokenStaff', doc);

        this.getPage(1);
    }


    // routerOnDeactivate() {
    //     this.subscription.unsubscribe();
    // }


    // routerOnActivate() {
    //     this.timer = Observable.timer(10000);
    //     this.subscription = this.timer.subscribe(() => {
    //         this.getPage(1);
    //         this.date = new Date();
    //     });
    // }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-list/token-list.component.ts